import {
  Routes,
  Route,
} from "react-router-dom"
import FullHome from "./Component/FullHome";
import Profile from "./Component/Profile/Profile";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route  path="/" element={<FullHome/>} />
        <Route path="/Dhaxal" element={<p>""</p>} />         
        <Route exact path="/Profile" element={<Profile />} />
      </Routes>
    </div>
  );
}

export default App;
